import {
    getProfileMatchingComponentDetailsModalController
} from "../profile-matching-modals/profile-matching-component-details-modal/profile_matching_component_details.modal.js";
import {getDislikeReasonsModalController} from "../profile-matching-modals/dislike-reasons-modal/dislike-reasons.modal.js";

(function () {

    "use strict";

    angular
        .module("harriApp")
        .component("speedyScreenProfileMatchingCard", {
            controller: speedyScreenProfileMatchingCard,
            bindings: {
                componentData: "<",
                userData: "<",
                isProfileMatching: "<"
            },
            controllerAs: '$ctrl',
            templateUrl: '../modules/speedy_screen/components/profile-matching-card/profile-matching-card.component.html'
        });

    speedyScreenProfileMatchingCard.$inject = ['$modal','$filter', '$scope'];

    function speedyScreenProfileMatchingCard($modal, $filter, $scope) {
        const self = this;
        self.loading = true;
        self.applicantPMInfo = {};
        self.isLoadingFeedbacks = false;

        self.expandedComponentsCodes = {
            POSITION_CATEGORY_SIMILARITY: "POSITION_CATEGORY_SIMILARITY",
            EMPLOYER_DOMAIN_SIMILARITY: "EMPLOYER_DOMAIN_SIMILARITY",
            AVERAGE_TENURE: "AVERAGE_TENURE",
            EDUCATION_LEVEL: "EDUCATION_LEVEL",
            DISTANCE: "DISTANCE",
            SKILLS_MATCHING: "SKILLS_MATCHING"
        };

        self.US_RANGES = [
            { min: 0, max: 2, score: 100 },
            { min: 2, max: 4, score: 90 },
            { min: 4, max: 6, score: 80 },
            { min: 6, max: 11, score: 70 },
            { min: 11, max: 16, score: 60 },
            { min: 16, max: 20, score: 50 },
            { min: 20, max: 30, score: 40 },
            { min: 30, max: 35, score: 30 },
            { min: 35, max: 40, score: 20 },
            { min: 40, max: 50, score: 10 },
            { min: 50, max: Infinity, score: 0 }
        ];

        self.UK_RANGES = [
            { min: 0, max: 5, score: 100 },
            { min: 5, max: 10, score: 90 },
            { min: 10, max: 20, score: 80 },
            { min: 20, max: 30, score: 70 },
            { min: 30, max: 45, score: 60 },
            { min: 45, max: 60, score: 50 },
            { min: 60, max: 75, score: 30 },
            { min: 75, max: 100, score: 20 },
            { min: 100, max: 120, score: 10 },
            { min: 120, max: Infinity, score: 0 }
        ];

        self.$onInit = () => {
            init();
        };

        const init = async () => {
            self.brandId = self.userData?.brand_id;
            self.jobId = self.userData?.job?.id;
            self.contextBrandId = self.userData?.contextBrand?.id;
            self.isExpandedCard = Object.values(self.expandedComponentsCodes).includes(self.componentData.code) && self.componentData?.isExpandedCard;
            self.isLikedComponent = self.componentData?.componentFeedback === 'UP';
            self.isDislikedComponent = self.componentData?.componentFeedback === 'DOWN';

            if(self.componentData?.top_candidates){
                await self.getTopCandidates(self.componentData.top_candidates);
            }
        };

        self.postComponentFeedback = (thumbType, isLiked = false, note = "", extraNote = "") => {
            self.isLoadingFeedbacks = true;
            return ProfileMatchingAPI.postComponentFeedback(
                self.brandId,
                self.jobId,
                self.componentData.jobApplicationId,
                {
                    component_id: self.componentData.id,
                    thumb_type: thumbType,
                    note: note,
                    extra_note: extraNote
                }
            ).then((res) => {
                if (res.status === 'SUCCESS') {
                    if (isLiked){
                        self.isLikedComponent = !self.isLikedComponent;
                        self.isDislikedComponent = false;
                    } else {
                        self.isDislikedComponent = !self.isDislikedComponent;
                        self.isLikedComponent = false;
                    }
                    self.showSuccessNotification();
                } else {
                    self.showFailureNotification();
                }
            }).catch((err) => {
                console.error(err);
                self.showFailureNotification();
            }).finally(() => {
                $scope.$digest();
                self.isLoadingFeedbacks = false;
            });
        };

        self.dislikeClicked = () => {
            if (!self.isDislikedComponent) {
                const modalData = () => ({
                    dislikeReasons: self.componentData.dislikeReasons
                });

                const onSave = (data) => {
                    self.postComponentFeedback("DOWN", false, data.userSelected, data.additionalReason);
                };

                $modal(getDislikeReasonsModalController(modalData, onSave));
            } else {
                self.postComponentFeedback("DELETED");
            }
        };

        self.likeClicked = () => {
            self.postComponentFeedback(self.isLikedComponent ? "DELETED" : "UP", true);
        };

        self.getTooltipAsHtml = (tooltipText) => {
            return `
                <div class="text-left">
                           ${$filter('translate')(tooltipText)}
                </div>`;
        };

        self.expandCard = async () => {
            let modalData;
            switch (self.componentData.code){
                case self.expandedComponentsCodes.POSITION_CATEGORY_SIMILARITY:
                    modalData = () => {
                        return {
                            title: self.componentData.business_name,
                            description: $filter('translate')('The score is normalized based on the highest job title Years of Experience (100% = ') + self.componentData.max_score + $filter('translate')(' years)') +
                                $filter('translate')('. Candidate\'s  Job Title Years of Experience = ') + (self.componentData.years_of_experience || 0) + ' years',
                            topCandidates: self.topCandidates,
                            applicationId: self.componentData.jobApplicationId,
                            jobId: self.jobId,
                        };
                    };
                    break;
                case self.expandedComponentsCodes.EMPLOYER_DOMAIN_SIMILARITY:
                    modalData = () => {
                        return {
                            title: self.componentData.business_name,
                            description: `${$filter('translate')('The score is normalized based on the highest Industry Years of Experience (100% = ')}${self.componentData.max_score} ${$filter('translate')('years)')}.` +
                            `${$filter('translate')(' Candidate\'s Industry Years of Experience') + ' = ' + (self.componentData.years_of_experience || 0)} years`,
                            topCandidates: self.topCandidates,
                            applicationId: self.componentData.jobApplicationId,
                            jobId: self.jobId,
                        };
                    };
                    break;
                case self.expandedComponentsCodes.AVERAGE_TENURE:
                    modalData = () => {
                        return {
                            title: self.componentData.business_name,
                            description: $filter('translate')('The score is normalized to the applicant with the highest stability ratio (experience relative to positions and employers), set at 100%, and all others are scaled accordingly.'),
                            topCandidates: self.topCandidates,
                            applicationId: self.componentData.jobApplicationId,
                            jobId: self.jobId,
                        };
                    };
                    break;
                case self.expandedComponentsCodes.DISTANCE:
                    modalData = () => {
                        return {
                            title: self.componentData.business_name,
                            description: self.getDistanceComponentNote(
                                self.componentData,
                                $filter("translate")('Score is calculated based on predefined ranges recommended by Profile Matching')
                            )
                        };
                    };
                    break;
                case self.expandedComponentsCodes.EDUCATION_LEVEL:
                    const educationLevel = self.componentData.education_level === 'Doctoral' ? 'PhD' : self.componentData.education_level;
                    modalData = () => {
                       return {
                           title: self.componentData.business_name,
                           topCandidates: self.topCandidates,
                           applicationId: self.componentData.jobApplicationId,
                           jobId: self.jobId,
                           description: `${$filter('translate')('The score is based on degree level, with a PhD as the highest (100%) and other levels scored proportionally')}. 
                           ${self.componentData.education_level ? $filter('translate')('The candidate\'s highest degree is') + ' ' + educationLevel : $filter('translate')('Candidate has no degree')}.`
                       };
                    };
                    break;
                case self.expandedComponentsCodes.SKILLS_MATCHING:
                    modalData = () => {
                        return {
                            title: $filter("translate")("Job skills match"),
                            description: $filter("translate")("The score is calculated as the percentage of matched skills out of the total required skills for the job."),
                            matchedSkills: self.componentData.matched_skills,
                            unmatchedSkills: self.componentData.unmatched_skills,
                            cvLanguage: self.componentData.cvLanguage,
                            jobLanguage: self.componentData.jobLanguage,
                        };
                    };
                    break;
                default:
            }
            $modal(getProfileMatchingComponentDetailsModalController(modalData));
        };

        self.getDistanceComponentNote = (component, mainMessage) => {
            const ranges = component.unit === 'miles' ? self.US_RANGES : component.unit === 'kilometers' ? self.UK_RANGES : [];
            const range = ranges.find(range => component.distance >= range.min && component.distance < range.max);
            const distanceLabel = $filter('translate')('. Candidate\'s distance: ');
            const unitLabel =  component.unit === 'miles' ? $filter('translate')('miles.') : $filter('translate')('kilometers.');

            if (range) {
                const exampleNote = range.max === Infinity ?
                    `(>${range.min} ${component.unit} = ${range.score}%)` :
                    `(${range.min}-${range.max} ${component.unit} = ${range.score}%)`;
                return `${mainMessage} ${exampleNote}${distanceLabel}${parseFloat(component.distance.toFixed(2))} ${unitLabel}`;
            }

            return `${mainMessage} ${distanceLabel}${parseFloat(component.distance.toFixed(2))} ${unitLabel}`;
        };

        self.getTopCandidates = (topCandidatesIds) => {
            JobApplicationAPI.getTopCandidates(self.brandId, self.jobId, {
                ids: topCandidatesIds,
                include_job: false,
                include_applicant_media: true,
            }).then((res)=> {
                self.topCandidates = res?.applications?.map((application) => ({
                    fullName: `${application.applicant?.first_name} ${application.applicant?.last_name}`,
                    profileImageURL: MediaUtils.hUserProfileImage([application.applicant?.profile_image?.uuid, application.applicant?.id], "_image_profile_full", true),
                    applicantId: application.id
                }));
            }).catch((err) => {
                console.error(err);
            }).finally(() => {
                $scope.$digest();

            });
        };

        self.showSuccessNotification = () => {
            HNotifications.show({
                title: $filter("translate")("Feedback submitted successfully!"),
                desc: '',
                icon: "fa-check-circle",
                type: "success",
                timeout: 10000
            })
        };

        self.showFailureNotification = () => {
            HNotifications.show({
                title: $filter("translate")("Submission failed"),
                desc: $filter("translate")('We couldn\'t process your feedback. Please try again.'),
                icon: "fa-times-circle",
                type: "danger",
                timeout: 10000
            })
        };

        self.$onDestroy = () => {
        };
    }
})();